import { logger } from '@activebrands/core-web/utils/logger';

/**
 * SHA-1 hex digest. Impact requires `customerEmail` hashed, and an empty
 * string — never null/undefined — when unavailable.
 *
 * `crypto.subtle` needs a secure context: HTTPS or localhost, not a LAN IP.
 */
export const sha1 = async (value: string): Promise<string> => {
    if (!value || typeof window === 'undefined' || !window.crypto?.subtle) {
        return '';
    }

    try {
        const bytes = new TextEncoder().encode(value.trim().toLowerCase());
        const digest = await window.crypto.subtle.digest('SHA-1', bytes);

        return Array.from(new Uint8Array(digest))
            .map(byte => byte.toString(16).padStart(2, '0'))
            .join('');
    } catch (error) {
        logger.error(error);
        return '';
    }
};
